import { connect } from 'react-redux'
import OneClickSubscribe from './OneClickSubscribePage'

const mapStateToProps = (state, { location: { state: values } }) => ({
  values
})

export default connect(mapStateToProps, null)(OneClickSubscribe)
